import PropTypes from 'prop-types';
import React from 'react';

const Table = ({headings, rows, sort, currentSort, sortDirection}) => {
  return <table className='table table-biolab table-striped'>
    <thead>
      <tr>
        {headings.map((x, i) => {
          if (!x || typeof x === 'string') {
            return <th key={i}>{x}</th>;
          }
          if (x.sortKey) {
            return <th style={Object.assign({cursor: 'pointer'}, x.style || {})} className={x.className} key={i} onClick={sort.bind(null, x.sortKey)}>
              {x.label}
              {currentSort === x.sortKey ?
                <i style={{fontSize: '0.7em', marginLeft: 10}} className={'bl bl-' + (sortDirection === 'asc' ? 'up' : 'dropdown')} /> :
                <i style={{fontSize: '0.7em', marginLeft: 10, opacity: 0.5}} className={'bl bl-' + (sortDirection === 'asc' ? 'up' : 'dropdown')} />
              }
            </th>;
          }
          return <th key={i} style={x.style} className={x.className}>{x.label}</th>;
        })}
      </tr>
    </thead>
    <tbody>
      {rows}
    </tbody>
  </table>;
};

Table.propTypes = {
  headings: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  sort: PropTypes.func,
  currentSort: PropTypes.string,
  sortDirection: PropTypes.oneOf(['asc', 'desc']),
};

export default Table;
